package no.vareflow.app.domain

/** Roles, permissions and user accounts. Pure Kotlin: no Android or Compose imports. */

enum class Role { ADMIN, LEADER, EMPLOYEE }

enum class Permission(private val nb: String, private val en: String) {
    INVENTORY_COUNT_ASSIGNED("Telle tildelte kategorier", "Count assigned categories"),
    INVENTORY_VIEW_OTHER("Se andre kategorier", "See other categories"),
    PRODUCT_VIEW_PRICE("Se innkjøpspris", "See purchase price"),
    PRODUCT_EDIT_NAME("Redigere varenavn", "Edit product name"),
    PRODUCT_EDIT_NUMBER("Redigere varenummer", "Edit product number"),
    PRODUCT_EDIT_CATEGORY("Redigere kategori", "Edit category"),
    PRODUCT_EDIT_UNIT("Redigere enhet", "Edit unit"),
    PRODUCT_EDIT_VAT("Redigere MVA", "Edit VAT"),
    PRODUCT_EDIT_PRICE("Redigere innkjøpspris", "Edit purchase price"),
    PRODUCT_EDIT_SUPPLIER("Redigere leverandør", "Edit supplier"),
    PRODUCT_EDIT_ALIASES("Redigere søke- og talealiaser", "Edit search and voice aliases"),
    PRODUCT_EDIT_ACTIVE("Aktivere / deaktivere produkt", "Activate / deactivate product"),
    PRODUCT_REVIEW_QUALITY("Godkjenne datakvalitet", "Approve data quality"),
    INVENTORY_ASSIGN_CATEGORY("Fordele kategorier", "Assign categories"),
    INVENTORY_CLOSE("Avslutte varetelling", "Close stock count"),
    SPOTCHECK_PERFORM("Utføre stikkprøver", "Do spot checks"),
    AUDIT_VIEW("Se auditlogg", "See audit log"),
    USER_MANAGE("Administrere brukere og rettigheter", "Manage users and permissions");

    val label: String get() = t(nb, en)
}

fun defaultPermissions(role: Role): Set<Permission> = when (role) {
    Role.ADMIN -> Permission.entries.toSet()
    Role.LEADER -> setOf(
        Permission.INVENTORY_COUNT_ASSIGNED,
        Permission.INVENTORY_VIEW_OTHER,
        Permission.PRODUCT_VIEW_PRICE,
        Permission.INVENTORY_ASSIGN_CATEGORY,
        Permission.INVENTORY_CLOSE,
        Permission.SPOTCHECK_PERFORM,
        Permission.AUDIT_VIEW
    )
    Role.EMPLOYEE -> setOf(Permission.INVENTORY_COUNT_ASSIGNED)
}

data class UserAccount(
    val id: String = randomId(),
    val name: String,
    val username: String,
    val password: String,
    val role: Role,
    val allowedCategories: Set<String>,
    val permissions: Set<Permission> = defaultPermissions(role),
    val accessUntil: Long? = null,
    val active: Boolean = true
)
